import createAPI from '../axios'

// 通用方法 API
const common = {
    // 下拉框选项
    comboOption: {
        year: config => createAPI('/common/comboOption/year', 'post', config),

        yearAdultEducation: config => createAPI('/common/comboOption/yearAdultEducation', 'post', config),

        yearSkillsTraining: config => createAPI('/common/comboOption/yearSkillsTraining', 'post', config),

        semester: config => createAPI('/common/comboOption/semester', 'post', config),

        dept: config => createAPI('/common/comboOption/dept', 'post', config),

        deptAdultEducation: config => createAPI('/common/comboOption/deptAdultEducation', 'post', config),

        deptSkillsTraining: config => createAPI('/common/comboOption/deptSkillsTraining', 'post', config),

        major: config => createAPI('/common/comboOption/major', 'post', config),

        majorAdultEducation: config => createAPI('/common/comboOption/majorAdultEducation', 'post', config),

        majorSkillsTraining: config => createAPI('/common/comboOption/majorSkillsTraining', 'post', config),

        grade: config => createAPI('/common/comboOption/grade', 'post', config),

        gradeAdultEducation: config => createAPI('/common/comboOption/gradeAdultEducation', 'post', config),

        gradeSkillsTraining: config => createAPI('/common/comboOption/gradeSkillsTraining', 'post', config),

        class: config => createAPI('/common/comboOption/class', 'post', config),

        classAdultEducation: config => createAPI('/common/comboOption/classAdultEducation', 'post', config),

        classSkillsTraining: config => createAPI('/common/comboOption/classSkillsTraining', 'post', config),

        auditState: config => createAPI('/common/comboOption/auditState', 'post', config),

        common: config => createAPI('/common/comboOption/common', 'post', config),

        weekDay: config => createAPI('/common/comboOption/weekDay', 'post', config),

        period: config => createAPI('/common/comboOption/period', 'post', config),

        custom: config => createAPI('/common/comboOption/custom', 'post', config),
    },

    // 文件管理
    file: {
        del: config => createAPI('/common/file/del', 'post', config),
    },

    // 审核
    audit: {
        auditParam: config => createAPI('/common/audit/auditParam', 'post', config),

        audit: config => createAPI('/common/audit/audit', 'post', config),

        list: config => createAPI('/common/audit/list', 'post', config),
    },

    // 审核配置
    auditConfig: {
        itemList: config => createAPI('/common/auditConfig/itemList', 'post', config),

        saveItem: config => createAPI('/common/auditConfig/saveItem', 'post', config),

        delItem: config => createAPI('/common/auditConfig/delItem', 'post', config),

        authList: config => createAPI('/common/auditConfig/authList', 'post', config),

        initCombo: config => createAPI('/common/auditConfig/initCombo', 'post', config),

        saveAuth: config => createAPI('/common/auditConfig/saveAuth', 'post', config),

        delAuth: config => createAPI('/common/auditConfig/delAuth', 'post', config),

        changeAuditLevel: config => createAPI('/common/auditConfig/changeAuditLevel', 'post', config),
    },

    // 数据流转
    dataExchange: {
        dept: config => createAPI('/syncData/department', 'post', config),

        tea: config => createAPI('/syncData/teacher', 'post', config),

        stuRecruit: config => createAPI('/syncData/stuRecruit', 'post', config),

        stuRegister: config => createAPI('/syncData/stuRegister', 'post', config),

        stuStatus: config => createAPI('/syncData/stuStatus', 'post', config),

        course: config => createAPI('/syncData/course', 'post', config),

        scheme: config => createAPI('/syncData/scheme', 'post', config),

        teachingTask: config => createAPI('/handleData/teachingTask', 'post', config),

        timetable: config => createAPI('/handleData/timetable', 'post', config),

        stuCourse: config => createAPI('/handleData/stuCourse', 'post', config),

        score: config => createAPI('/handleData/score', 'post', config),

        class: config => createAPI('/api/class', 'post', config),

        courseAndSiteStatistics: config => createAPI('/handleData/courseAndSiteStatistics', 'post', config),

        electiveCourse: config => createAPI('/handleData/electiveCourse', 'post', config),
    }
};

export default common;



// WEBPACK FOOTER //
// ./src/api/modules/common.js